import "@shadcn-test/styles/global.css";
import { StrictMode, Suspense } from "react";
import * as ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./app/app";
import GlobalErrorBoundary from "./app/components/GlobalErrorBoundary";
import "./i18n"; // Import i18n initialization

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
    <StrictMode>
        <GlobalErrorBoundary>
            <Suspense
                fallback={
                    <div className="flex h-screen items-center justify-center">
                        Loading...
                    </div>
                }
            >
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            </Suspense>
        </GlobalErrorBoundary>
    </StrictMode>
);
